module.exports = __webpack_public_path__ + "img/chat-6.26eff943.svg";